import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type MultiFilter,
  type RangeFilter,
} from '../types/filters';
import {
  yearsOfExperienceDefinition,
  yearsOfExperienceHandler,
} from './yearsOfExperience';

export const multiYearsOfExperienceDefinition: FilterDefinition<
  MultiFilter<RangeFilter>
> = {
  id: FilterId.MULTI_YEARS_OF_EXPERIENCE,
  name: 'Years of Experience',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.YEARS_OF_EXPERIENCE,
  instances: [],
  isVisible: true,
};

export const multiYearsOfExperienceHandler: FilterHandler<
  MultiFilter<RangeFilter>
> = {
  isActive(currentFilterState: MultiFilter<RangeFilter>) {
    return currentFilterState.instances.some((instance) =>
      yearsOfExperienceHandler.isActive(instance)
    );
  },

  isDefault(
    currentFilterState: MultiFilter<RangeFilter>,
    _definition: FilterDefinition<MultiFilter<RangeFilter>>
  ) {
    return currentFilterState.instances.length === 0;
  },

  getEffectiveFilter(
    currentFilterState: MultiFilter<RangeFilter>,
    _definition: FilterDefinition<MultiFilter<RangeFilter>>,
    config: FilterConfig
  ) {
    const effectiveInstances = currentFilterState.instances.map((instance) =>
      yearsOfExperienceHandler.getEffectiveFilter(
        instance,
        yearsOfExperienceDefinition,
        config
      )
    );
    return { ...currentFilterState, instances: effectiveInstances };
  },
};
